import { getCardPayment, getOpenBankingPayment, getPaymentRequest } from "@api";
import { useEffect } from "react";
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import PaymentProcessing from "../../shared/PaymentProcessing";

const EapProcessing = () => {
  const { customer, setPayment, contactId } = useOutletContext();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("p-id");
  const type = searchParams.get("t");

  useEffect(() => {
    const pollPaymentStatus = async () => {

      let paymentData = null;
      if (type === "card") {
        paymentData = await getCardPayment(paymentId);
      }
      if (type === "openbanking") {
        paymentData = await getOpenBankingPayment(paymentId);
      }

      if (paymentData.status === "Processing" || paymentData.status === "Initialized") {
        setTimeout(pollPaymentStatus, 500);
      }
      else if (paymentData.status === "PaymentSucceeded") {
        setPayment(paymentData);
        navigate(`/embeddedaccountpayment/success?cu=${contactId}`);
        return;
      }
      else {
        setPayment(paymentData);
        navigate(`/embeddedaccountpayment/paymentfailed?cu=${contactId}`);
      }
    }

    if (paymentId && type) {
      pollPaymentStatus();
    }
    else {
      navigate(`/embeddedaccountpayment/paymentfailed?cu=${contactId}`);
    }
  }, [type, paymentId]);

  return (<PaymentProcessing merchant={customer.merchant} />);
};

export default EapProcessing;
